import { Tag, type TagProps } from 'antd';
import { type Role } from 'models/user';

export const ROLE_COLOR: Record<Role, string> = {
  ADMIN: 'volcano',
  PARTNER: 'orange',
  HEAD: 'magenta',
  TEAM_LEAD: 'purple',
  BUYER: 'processing',
  BIZDEV: 'cyan',
  MANAGER: 'green',
  FARMER: 'gold',
  HR: 'yellow',
  NEW_USER: 'default',
};

interface RoleTagProps extends TagProps {
  roleType: Role;
}

export const RoleTag = ({ roleType, ...props }: RoleTagProps) => {
  const color = ROLE_COLOR[roleType];

  return (
    <Tag color={color} {...props}>
      {roleType.replace('_', ' ')}
    </Tag>
  );
};
